// AuthGuard.tsx
import { Box, CircularProgress } from '@mui/material';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './useAuth';

export default function AuthGuard() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress color={'primary'} />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to={'/login'} replace />;
  }

  return <Outlet />;
}
